<script setup>
// The split of the CSAT answers over the five ratings, as the kit's RatingDistribution (R3), named with the woot's
// ratings by name only, without the emoji (R3-15 = B: Ruim, Neutro, Mediano, Bom, Excelente). The kit counts the
// shares from the counts.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { CSAT_RATINGS } from 'shared/constants/messages';
import RatingDistribution from 'dashboard/components-next/polaris/reports/RatingDistribution.vue';
import { csatRatingNames } from './Csat/csatRatingNames';

const props = defineProps({
  ratingCount: {
    type: Object,
    default: () => ({}),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
const names = computed(() => csatRatingNames(t));
const counts = computed(() =>
  Object.fromEntries(
    CSAT_RATINGS.map(rating => [
      rating.value,
      Number(props.ratingCount[rating.value] || 0),
    ])
  )
);
</script>

<template>
  <RatingDistribution
    :counts="counts"
    :names="names"
    :label="t('CSAT_REPORTS.METRIC.RATING_DISTRIBUTION')"
    :loading="isLoading"
  />
</template>
